import React, { useState, useEffect } from "react";
import "../select/Select.js";
import "react-intl";
import "@mui/material";
import "../chip/ChipRenderer.js";
import "../select/selectStyle.js";
import "../select/MultiSelectFooter.js";
import "../select/MultiSelect.js";
import "../select/MultiSelectItem.js";
import "../select/SelectArrowIcon.js";
import "../select/VirtualizedMultiSelectOptionList.js";
import "../select/SingleSelect.js";
import { MultiSelectWithExclude } from "../select/MultiSelectWithExclude.js";
import "../select/MultiSelectTextCounterWithTooltip.js";
import "moment-timezone";
import { removeItemsFromArray } from "../../utils/array.js";
function MultiSelectWithExcludeFilter({ value: includedItems, onChange, ...props }) {
  const { total, options } = props;
  const [currentValue, setCurrentValue] = useState(getInitialValue());
  const [initialMode, setInitialMode] = useState("exclude");
  useEffect(() => {
    setCurrentValue(getInitialValue());
  }, [includedItems?.join()]);
  useEffect(() => {
    if (total > 0) {
      setCurrentValue(getInitialValue());
      setInitialMode(isIncludeMode(includedItems?.length) ? "include" : "exclude");
    }
  }, [total]);
  function getInitialValue() {
    const result = { include: [], exclude: [] };
    if (includedItems?.length && total > 0) {
      if (isIncludeMode(includedItems?.length)) {
        result.include = includedItems;
      } else {
        result.exclude = options?.map((o) => o.value?.toString())?.filter((o) => !includedItems.includes(o));
      }
    }
    return result;
  }
  function handleValueChange(newModel) {
    setCurrentValue(newModel);
  }
  function handleApply() {
    const allValues = options?.map((o) => o.value) ?? [];
    let result = null;
    if (currentValue?.include?.length) {
      result = currentValue?.include;
    } else if (currentValue?.exclude?.length) {
      result = removeItemsFromArray(allValues, ...currentValue?.exclude ?? []);
    }
    onChange(result);
  }
  function isIncludeMode(includedItemsCount) {
    return includedItemsCount <= total - includedItemsCount;
  }
  return /* @__PURE__ */ React.createElement(
    MultiSelectWithExclude,
    {
      hasSearch: true,
      filteredTotal: props.total,
      value: currentValue,
      onValueChange: handleValueChange,
      showApplyButton: true,
      onApply: handleApply,
      inputChipColor: "primary",
      initialMode,
      ...props
    }
  );
}
export {
  MultiSelectWithExcludeFilter
};
//# sourceMappingURL=MultiSelectWithExcludeFilter.js.map
